import { actions } from '../constants/iFrame';
import { IPayloadIFrame } from '../../models/components/iframe';

export function getIFrameSource(iFramePayload: any, spinnerId?: string, spinnerType?: 'get' | 'set'): any {
    return {
        iFramePayload,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_IFRAME_SOURCE
    };
}

export function SetIFrameSource(returnUrl: any, spinnerId?: string, spinnerType?: 'get' | 'set'): any {
    return {
        returnUrl,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_IFRAME_SOURCE
    };
}
